import React, { useContext, useEffect } from 'react';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import PaymentPaid from './PaymentPaid/PaymentPaid';
import RegistrationFee from './RegistrationFee/RegistrationFee';
declare global {
  interface Window {
    Razorpay: any;
  }
}
const ApplicationFee = () => {
  const {
    registrationDetails
  } = useContext(RegistrationContext);
  useEffect(() => {
    const ele = document.createElement('script');
    ele.type = 'text/javascript';
    ele.async = true;
    ele.src = 'https://checkout.razorpay.com/v1/checkout.js';
    document.body.appendChild(ele);
    return () => {
      if (ele) {
        document.body.removeChild(ele);
        const razorpayContainer = document.querySelectorAll('.razorpay-container');
        razorpayContainer.forEach(container => {
          container.remove();
        });
      }
    };
  }, []);
  return <>{registrationDetails?.isPaid ? <PaymentPaid /> : <RegistrationFee />}</>;
};
export default ApplicationFee;